import { compose } from 'ramda';
import { createAction } from 'redux-actions';

import {
  SELECTED_SKU_RESET,
  SKU_SELECTED,
  FREE_TRIAL_SELECTED,
  FREE_TRIAL_STARTED,
  SUBSCRIPTION_STARTED,
  SUBSCRIPTION_REQUESTED,
  SUBSCRIPTION_SELECTED,
  SKIP_FREE_TRIAL_SET,
  SKIP_FREE_TRIAL_RESET,
  PRODUCTS_FETCHED,
  STORE_BENEFITS_FETCHED,
} from 'app/features/products/actionTypes';
import { getParsedSelectedSku } from 'app/router/selectors';

const skuSelected = createAction(SKU_SELECTED);
const selectedSkuReset = createAction(SELECTED_SKU_RESET);
const freeTrialSelected = createAction(FREE_TRIAL_SELECTED);
const freeTrialStarted = createAction(FREE_TRIAL_STARTED);
const subscriptionSelected = createAction(SUBSCRIPTION_SELECTED);
const subscriptionStarted = createAction(SUBSCRIPTION_STARTED);
const subscriptionRequested = createAction(SUBSCRIPTION_REQUESTED);
const skipFreeTrialSet = createAction(SKIP_FREE_TRIAL_SET);
const skipFreeTrialReset = createAction(SKIP_FREE_TRIAL_RESET);
const productsFetched = createAction(PRODUCTS_FETCHED);
const storeBenefitsFetched = createAction(STORE_BENEFITS_FETCHED);

const selectSkuFromGetParams = () => (dispatch, getState) => {
  const sku = getParsedSelectedSku(getState());

  if (sku) {
    dispatch(skuSelected(sku));
  }
};

function fetchProducts() {
  return (dispatch, _, { api }) =>
    api.fetchProducts().then(compose(dispatch, productsFetched));
}

export {
  skuSelected,
  selectedSkuReset,
  freeTrialSelected,
  freeTrialStarted,
  subscriptionSelected,
  subscriptionStarted,
  skipFreeTrialSet,
  skipFreeTrialReset,
  subscriptionRequested,
  selectSkuFromGetParams,
  productsFetched,
  fetchProducts,
  storeBenefitsFetched,
};
